import { render, staticRenderFns } from "./GlobalHeader.vue?vue&type=template&id=23bce11e&scoped=true&"
import script from "./GlobalHeader.vue?vue&type=script&lang=ts&"
export * from "./GlobalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalHeader.vue?vue&type=style&index=0&id=23bce11e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bce11e",
  null
  
)

export default component.exports